import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { MapPin, Search } from "lucide-react";
import SEO from "../components/SEO";
import CTASection from "../components/sections/CTASection";
import { getCities } from "../lib/api";

export default function IndianaCities() {
  const [cities, setCities] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { getCities().then(setCities).catch(() => {}); }, []);

  const filtered = useMemo(() => {
    if (!q) return cities;
    const lc = q.toLowerCase();
    return cities.filter((c) => c.city_name.toLowerCase().includes(lc) || (c.county || "").toLowerCase().includes(lc));
  }, [q, cities]);

  return (
    <>
      <SEO title="Indiana Cities | Local Accident Help by City" description="Find local accident help in Indianapolis, Fort Wayne, Evansville, South Bend, Carmel, Fishers, Bloomington, Lafayette, and dozens of other Indiana cities." />
      <section className="pt-12 md:pt-20 pb-12 px-6 bg-bone">
        <div className="max-w-7xl mx-auto">
          <div className="overline mb-3">Local Across Indiana</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5 text-balance max-w-3xl">
            Local Indiana attorneys in your city.
          </h1>
          <p className="text-lg text-charcoal-soft max-w-2xl mb-8">
            Browse city pages with Indiana-specific accident statistics, hospitals, highways, and county-court information.
          </p>

          <div className="relative max-w-md">
            <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-charcoal-soft" />
            <input
              type="text"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search by city or county..."
              className="w-full pl-12 pr-4 py-4 rounded-full border border-black/10 focus:border-forest focus:ring-2 focus:ring-forest/20 bg-white outline-none"
              data-testid="cities-search-input"
            />
          </div>
        </div>
      </section>

      <section className="px-6 pb-20">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filtered.map((c) => (
            <Link
              key={c.id}
              to={`/indiana-cities/${c.slug}`}
              className="bg-white rounded-xl border border-black/5 p-5 hover:border-terracotta hover:shadow-md hover:-translate-y-0.5 transition-all"
              data-testid={`city-card-${c.slug}`}
            >
              <div className="flex items-center gap-2 text-[10px] font-bold tracking-wider uppercase text-charcoal-soft mb-1">
                <MapPin className="w-3 h-3" /> {c.county}
              </div>
              <div className="font-display font-bold text-xl md:text-2xl text-forest leading-tight mb-1">{c.city_name}</div>
              <div className="text-xs text-charcoal-soft">{c.population} residents</div>
            </Link>
          ))}
          {filtered.length === 0 && (
            <p className="col-span-full text-center text-charcoal-soft py-12">No cities found matching "{q}"</p>
          )}
        </div>
      </section>
      <CTASection />
    </>
  );
}
